import { Component, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ResolucionMensual } from 'src/app/shared/models/cierreTurno/ResolucionMensual';
import { ReportesService } from 'src/app/reportes/reportes.service';
import { VisorInformeResolucionComponent } from '../visor-informe-resolucion/visor-informe-resolucion.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { MessageService } from 'src/app/shell/message.service';

@Component({
  selector: 'app-modal-generar-resolucion',
  templateUrl: './modal-generar-resolucion.component.html',
  styleUrls: ['./modal-generar-resolucion.component.scss']
})
export class ModalGenerarResolucionComponent {
  constructor(
    public activeModal: NgbModal, 
    private reportesService: ReportesService, 
    private messageService: MessageService) { }

  @Input() resolucion: ResolucionMensual;
  grabando: boolean = false;

  generarInforme() {
    this.grabando = true;
    this.reportesService.guardarResolucionMensual(this.resolucion).subscribe(res => {
      let modalRef = this.activeModal.open(VisorInformeResolucionComponent, { centered: true, size: 'xl' });
      modalRef.componentInstance.pdfSrc = this.reportesService.base64ToArrayBuffer(res.pdf);
      modalRef.componentInstance.fileName = `Resolución_${this.resolucion.codigoProducto}_${this.resolucion.periodo}.pdf`
      this.grabando = false;
    }, (error) => {
      this.grabando = false;
      this.messageService.showErrorMessage('Error al generar la resolución.')
    })
  }
}
